module.exports = __webpack_public_path__ + "img/img72.c92dd563.png";